<script>
  import { innerWidth, innerHeight } from 'svelte/reactivity/window';
  import { isApp } from '@st-graphics/graphics-kit/environment';
  import { Menu, Navbar } from '@st-graphics/graphics-components';
  import { Crown, Default } from './Options';

  let { head = {}, menu } = $props();

  const headerMap = {
    default: Default,
    crown: Crown,
  };

  let navbarSettings = {
    crown: { seamless: true },
    default: { seamless: true },
  };

  let isMobile = $derived(innerWidth.current < 744);
  const SvelteComponent = $derived(headerMap[head.mode] || headerMap.default);
</script>

<header>
  <SvelteComponent
    {...head}
    innerWidth={innerWidth.current}
    innerHeight={innerHeight.current}
    {isApp}
    {isMobile}
  >
    {#snippet navbar()}
      {#if !isApp}
        <Navbar {...navbarSettings[head.mode]} />
      {/if}
    {/snippet}

    {#snippet menuitems()}
      {#if menu}
        <Menu {...menu} />
      {/if}
    {/snippet}
  </SvelteComponent>
</header>

<style lang="scss">
  header {
    color: var(--st-blue);
  }

  :global {
    button[type='button'].btn-login,
    button[type='button'].btn-user {
      display: none;
    }
  }

  :global {
    .navbar {
      border-bottom: unset;
    }
  }

  :global {
    .menu-wrapper {
      p {
        margin-block: unset;
        font-family: 'Curator';
        font-weight: bold;
        font-size: 16px;
      }

      a {
        text-decoration: none;
        &.active {
          text-decoration: underline;
        }
      }

      .menu-title {
        display: inline-flex;

        &:before {
          content: '';
          display: inline-block;
          width: 1.25rem;
          height: 1.25rem;
          background-image: url(data:image/png;base64,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);
          background-size: cover;

          @media (min-width: 744px) {
            margin-top: -0.125rem;
            width: 1.5rem;
            height: 1.5rem;
          }
        }
      }
    }
  }

  :global {
    .article-headline {
      .headline {
        &:after {
          content: '';
          display: block;
          max-width: 1200px;
          margin: 0 auto;
          border-bottom: 1px solid #c0cac8;
          margin-bottom: 23px;
        }
      }

      h1.hed {
        font-size: 2rem !important;
        font-family: Selane Forty;
        font-weight: normal;

        @media (min-width: 744px) {
          font-family: Selane Twenty;
          font-size: 3.125rem !important;
          font-weight: normal;
        }
      }

      .dek {
        p {
          font-size: 1.35rem;
          --theme-colour-text-primary: var(--st-black);
          font-family: 'Selane Text';
          font-weight: normal;
        }
      }

      .byline {
        a {
          color: var(--st-links);
        }
      }
    }
  }
</style>
